import { Form, Formik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { TextInput } from "../../components/Form/Form";
import { useDispatch } from "react-redux";
import { register } from "../../store/actions/auth";

function Signup() {
  const dispatch = useDispatch();
  return (
    <div>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="company-logo p-25">
                <img src="/logo.png" alt="luhaif-logo" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="signup-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="signup-box">
                <div className="signup-form-content">
                  <div className="signup-form-heading">
                    <h3>Start Your Free Trial</h3>
                  </div>
                  <div className="signup-form-text">
                    Create your <span>LEDSAK</span> account. No credit card
                    required.
                  </div>
                </div>
                <div className="signup-form">
                  <Formik
                    initialValues={{
                      name: "",
                      email: "",
                      phone: "",
                      company_name: "",
                      password: "",
                    }}
                    validationSchema={Yup.object({
                      name: Yup.string().required("Required"),
                      email: Yup.string().required("Required"),
                      phone: Yup.string().required("Required"),
                      password: Yup.string().required("Required"),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                      setSubmitting(true);
                      dispatch(register(values));
                      resetForm();
                      setSubmitting(false);
                    }}
                  >
                    {(formik) => {
                      console.log(formik);
                      return (
                        <Form>
                          <div className="row">
                            <div className="form-group pb-12">
                              <TextInput label="Name" name="name" type="text" />
                            </div>
                            <div className="form-group pb-12">
                              <TextInput
                                label="Email"
                                name="email"
                                type="text"
                              />
                            </div>
                            <div className="form-group pb-12">
                              <TextInput
                                label="Phone"
                                name="phone"
                                type="text"
                              />
                            </div>
                            <div className="form-group pb-12">
                              <TextInput
                                label="Company Name"
                                name="company_name"
                                type="text"
                              />
                            </div>
                            <div className="form-group pb-12">
                              <TextInput
                                label="Password"
                                name="password"
                                type="password"
                              />
                            </div>
                          </div>
                          <div className="pt-20">
                            <button type="submit" className="button-31 p">
                              Create Account
                            </button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
                <div className="signup-box-footer-text">
                  Already have an account? <Link to="/login">SIGN IN</Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="signup-page-side-img">
                <img
                  src="/assets/images/v955-audi-instagram-10-ps.jpg"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Signup;
